import TablaConciliacion from "../../../TablaConciliacion";

function TablaRutaalMar() {
  return <TablaConciliacion nombreUseCase="rutaalmar" titulo="RUTA AL MAR" />;
}

export default TablaRutaalMar;
